{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "{conversationCount} conversations selected",
    "AGENT_SELECT_LABEL": "Изберете агент",
    "ASSIGN_CONFIRMATION_LABEL": "Are you sure to assign {conversationCount} {conversationLabel} to",
    "UNASSIGN_CONFIRMATION_LABEL": "Are you sure to unassign {conversationCount} {conversationLabel}?",
    "GO_BACK_LABEL": "Go back",
    "ASSIGN_LABEL": "Assign",
    "YES": "Yes",
    "SEARCH_INPUT_PLACEHOLDER": "Търсене",
    "ASSIGN_AGENT_TOOLTIP": "Assign agent",
    "ASSIGN_TEAM_TOOLTIP": "Assign team",
    "ASSIGN_SUCCESFUL": "Conversations assigned successfully.",
    "ASSIGN_FAILED": "Failed to assign conversations. Please try again.",
    "RESOLVE_SUCCESFUL": "Conversations resolved successfully.",
    "RESOLVE_FAILED": "Failed to resolve conversations. Please try again.",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "Conversations visible on this page are only selected.",
    "AGENT_LIST_LOADING": "Loading agents",
    "UPDATE": {
      "CHANGE_STATUS": "Change status",
      "SNOOZE_UNTIL": "Snooze",
      "UPDATE_SUCCESFUL": "Conversation status updated successfully.",
      "UPDATE_FAILED": "Failed to update conversations. Please try again."
    },
    "LABELS": {
      "ASSIGN_LABELS": "Assign labels",
      "NO_LABELS_FOUND": "No labels found for",
      "ASSIGN_SELECTED_LABELS": "Assign selected labels",
      "ASSIGN_SUCCESFUL": "Labels assigned successfully.",
      "ASSIGN_FAILED": "Failed to assign labels. Please try again."
    },
    "TEAMS": {
      "TEAM_SELECT_LABEL": "Изберете екип",
      "NONE": "Нито един",
      "NO_TEAMS_AVAILABLE": "There are no teams added to this account yet.",
      "ASSIGN_SELECTED_TEAMS": "Assign selected team.",
      "ASSIGN_SUCCESFUL": "Teams assigned successfully.",
      "ASSIGN_FAILED": "Failed to assign team. Please try again."
    },
    "MERGE": {
      "TOOLTIP": "Обединяване на разговори",
      "TITLE": "Обединяване на разговори",
      "DESCRIPTION": "Изберете целеви разговор. Всички останали избрани разговори ще бъдат обединени в него — техните съобщения ще бъдат преместени в целевия, а изходните разговори ще бъдат изтрити.",
      "TARGET_LABEL": "Целеви разговор (ще бъде запазен)",
      "SOURCES_LABEL": "Изходни разговори (ще бъдат изтрити)",
      "SELECT_TARGET": "Изберете разговор като цел на обединяването",
      "WARNING": "Внимание: Това действие не може да бъде отменено. Съобщенията от всички изходни разговори ще бъдат преместени в целевия разговор, а изходните разговори ще бъдат изтрити за постоянно.",
      "SUBMIT": "Обединяване на разговори",
      "CANCEL": "Отказ",
      "SUCCESS_MESSAGE": "Разговорите са обединени успешно",
      "ERROR_MESSAGE": "Не можахме да обединим разговорите. Моля, опитайте отново.",
      "CONFIRM": {
        "TITLE": "Потвърждение на обединяването",
        "DESCRIPTION": "Сигурни ли сте, че искате да обедините {sourceCount} разговора в #{targetId}? Това действие не може да бъде отменено.",
        "YES": "Да, обедини",
        "CANCEL": "Отказ"
      }
    }
  }
}
